import { httpClient } from '@/network/clientController'

/** Gets List of Provinces with municipies inside each province
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetlocation
*/
export const getListEconomicActivities = payload => {
	return httpClient({
		method: 'GET',
		url: 'location',
		isCancellable: true
	})
}
